import { createContext } from "react";
import { selectLanguage } from "../../data/languages/language.manager";
import { useLanguage } from "../../hooks/language/language.hook";

const LanguageContext = createContext({
  l: selectLanguage("en"),
  changeLanguage: (newLanguage: "en" | "fr") => {},
});

const LanguageProvider = ({ children }: any) => {
  const { language, changeLanguage } = useLanguage();

  return (
    <LanguageContext.Provider value={{ l: language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export { LanguageContext, LanguageProvider };
